import AppConstants from '../config/app.constants';

let OrderViewService = function ($http, $q) {

    let getAtmOrders = (searchText, branchId, startDate, endDate, orderStat, fundingSourceId, customerId, locationId, orderType, routeId, status, denominationId) => {
        return $http
            .get(AppConstants.api + `/order-view/get-atm-orders`, {
                params: {
                    searchText,
                    branchId,
                    startDate,
                    endDate,
                    orderStat,
                    fundingSourceId,
                    customerId,
                    locationId,
                    orderType,
                    routeId,
                    status,
                    denominationId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let findLocationRoute = (locationId, date) => {
        return $http
            .get(AppConstants.api + `/order-view/find-location-route`, {
                params: {
                    locationId,
                    date
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let createAtmOrders = (data) => {
        return $http
            .post(AppConstants.api + `/order-view/create-atm-orders`, data)
            .then((res) => {
                return res.data
            })
    }

    // let updateShipment = (orderNo, locationId, orderType, vaultDate, routeId, branchId, cashOrderId, denominations ) => {
    //     return $http
    //         .post(AppConstants.api + `/order-view/update-shipment`, {
    //             orderNo, locationId, orderType, vaultDate, routeId, branchId, cashOrderId, denominations 
    //         })
    //         .then((res) => {
    //             return res.data
    //         })
    // }

    let cancelAtmOrder = (cashOrderId, branchId, userId) => {
        return $http
            .post(AppConstants.api + `/order-view/cancel-atm-order`, { cashOrderId, branchId, userId })
            .then((res) => {
                return res.data
            })
    }

    let updateScheduledShipment = (denominations, locationId, locationScheduleRecurringId) => {
        return $http
            .post(AppConstants.api + `/order-view/update-scheduled-shipment`, { denominations, locationId, locationScheduleRecurringId })
            .then((res) => {
                return res.data
            })
    }

    let updatePendingPackShipment = (denominations, vaultDate, locationId, routeId, orderNo, orderType, amount, branchId, denominationId, supervisorId) => {
        return $http
            .post(AppConstants.api + `/order-view/update-pending-pack-shipment`, {
                denominations, vaultDate, locationId, routeId, orderNo, orderType, amount, branchId, denominationId, supervisorId
            })
            .then((res) => {
                return res.data
            })
    }

    let generateOrderNumber = () => {
        return $http
            .get(AppConstants.api + `/order-view/generate-order-number`, {})
            .then((res) => {
                return res.data
            })
    }

    let createAtmLoadShipments = (shipments) => {
        return $http
            .post(AppConstants.api + `/order-view/create-atm-load-shipments`, { shipments })
            .then((res) => {
                return res.data
            })
    }

    let getLocationOrdersSinceSwap = (locationId) => {
        return $http
            .get(AppConstants.api + `/order-view/get-location-orders-since-swap`, {
                params: {
                    locationId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let createRecurringATMLoadShipment = (shipments) => {
        return $http
            .post(AppConstants.api + `/order-view/create-recurring-atm-load-shipment`, { shipments })
            .then((res) => {
                return res.data
            })
    }

    let cancelRecurringATMLoadShipment = (jobKey, denominationId) => {
        return $http
            .post(AppConstants.api + `/order-view/cancel-recurring-atm-load-shipment`, { jobKey, denominationId })
            .then((res) => {
                return res.data
            })
    }

    let updatePackedCashBag = (trackingId, vaultDate, routeId, branchId, coinShipments, cashShipmentAmount) => {
        return $http
            .post(AppConstants.api + `/order-view/update-packed-cash-bag`, {
                trackingId, vaultDate, routeId, branchId, coinShipments, cashShipmentAmount
            })
            .then((res) => {
                return res.data
            })
    }

    let getFundingSourceDenomination = (branchFundingSourceId, locationId = null) => {
        const params = { branchFundingSourceId };
        if (locationId) {
            params.locationId = locationId;
        }
        return $http
            .get(AppConstants.api + `/order-view/get-funding-source-denomination`, {
                params
            })
            .then((res) => {
                return res.data
            })
    }

    let getFundingSourceDenominationUnpack = (branchFundingSourceId) => {
        return $http
            .get(AppConstants.api + `/order-view/get-funding-source-denomination-unpack`, {
                params: { branchFundingSourceId }
            })
            .then((res) => {
                return res.data
            })
    }
    
    let createPackableOrder = (obj) => {
        return $http
        .post(AppConstants.api + `/order-view/create-packable-order`, obj)
        .then((res) => {
            return res.data
        }) 
    }

    let updatePendingPackOrder = (denominations, vaultDate, locationId, routeId, orderNo, orderType, amount, branchId, denominationId, supervisorId) => {
        return $http
            .post(AppConstants.api + `/order-view/update-pending-pack-order`, {
                denominations, vaultDate, locationId, routeId, orderNo, orderType, amount, branchId, denominationId, supervisorId
            })
            .then((res) => {
                return res.data
            })
    }

    let updateRecurrinRoute = (combinedRoutes, deletedRecurringStops, locationId, branchId) => {
        return $http
            .post(AppConstants.api + `/order-view/update-recurring-route`, { combinedRoutes, deletedRecurringStops, locationId, branchId })
            .then((res) => {
                return res.data
            })
    }

    let convertScheduledOrderToPackableOrder = (fundingSourceId, locationId, recurringDate, userId, branchId) => {
        return $http
            .post(AppConstants.api + `/order-view/convert-scheduled-order-to-packable-order`, { fundingSourceId, locationId, recurringDate, userId, branchId })
            .then((res) => {
                return res.data
            })
    }

    return {
        getAtmOrders,
        findLocationRoute,
        createAtmOrders,
        updatePendingPackShipment,
        updatePendingPackOrder,
        cancelAtmOrder,
        generateOrderNumber,
        createAtmLoadShipments,
        getLocationOrdersSinceSwap,
        createRecurringATMLoadShipment,
        cancelRecurringATMLoadShipment,
        updatePackedCashBag,
        getFundingSourceDenominationUnpack,
        createPackableOrder,
        getFundingSourceDenomination,
        updateRecurrinRoute,
        updateScheduledShipment,
        convertScheduledOrderToPackableOrder
    };
}

OrderViewService.$inject = ['$http', '$q'];

export default OrderViewService;


// WEBPACK FOOTER //
// ./client/app/services/order-view.service.js